import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';

@Component({
  selector: 'app-redirect-player',
  templateUrl: './redirect-player.component.html',
  styleUrls: ['./redirect-player.component.less']
})
export class RedirectPlayerComponent implements OnInit {

  constructor(
    private _route: ActivatedRoute,
    private readonly _router: Router
  ) {
    // Getting route paramaters
    this._route.params.subscribe((params: Params) => {
      // console.log('Route rcv new params', params);
      this._router
        .navigate(['player', params['id'], 1, 0])
        .then(success => !success && console.log('Navigation failed'))
        .catch(e => console.error(e));
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/element/redirect-player/redirect-player.component.ts